import Depoimentos from "../components/Depoimentos";

export default function DepoimentosPage() {
  return (
    <div data-testid="page-depoimentos" className="pt-24 sm:pt-32">
      <Depoimentos />
    </div>
  );
}
